import { Component, ViewChild, ElementRef, Input, OnInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { URL_HTTPS_PROTOCOL, URL_PATH, URL_ROOT } from '@app/@core/constants/training.constants';
import { FeaturedPill } from '@app/training/model/training.model';
import { TrainingStore } from '@app/training/services/training.store';
import FileSaver from 'file-saver';

@Component({
  selector: 'scf-featured-card-item',
  templateUrl: './featured-card-item.component.html',
  styleUrls: ['./featured-card-item.component.scss'],
})
export class FeaturedCardItemComponent implements OnInit {
  @Input('data') element: FeaturedPill;

  size: string = '';
  type: string = '';
  isViewMoreClicked: boolean = false;
  hasURL: boolean = true;
  isExternalUrl: boolean = false;
  isVideo: boolean = false;

  constructor(private trainingStore: TrainingStore) {}
  ngOnInit(): void {
    const url = this.element?.url?.trim();
    this.hasURL = !!url;
    if (this.hasURL) {
      if (url?.startsWith(URL_ROOT)) {
        const route = URL_PATH + url;
        this.trainingStore.getPdfFromAssets(route).then((data) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileSize = Math.round(file?.size / 1000);
          this.size = fileSize?.toString();
        });
      } else if (url?.startsWith(URL_HTTPS_PROTOCOL)) {
        this.isExternalUrl = true;
        this.isVideo =
          this.trainingStore.getTutorialProvidersAllowed().filter((urlAllowed) => url.includes(urlAllowed))?.length > 0;
      } else console.error('URL/Path not supported.', url);
    }
  }

  onClickViewMore = () => {
    if (!!this.element?.url?.trim()) {
      window.open(this.element.url);
    }
  };

  onClickViewDocument = () => {
    const route = this.element.url.startsWith(URL_HTTPS_PROTOCOL)
      ? this.element.url?.trim()
      : this.element.url.startsWith(URL_ROOT)
      ? URL_PATH + this.element.url
      : null;
    route ? window.open(route) : console.error('URL/Path not supported.', route);
  };

  onClickDownloadDocument = () => {
    if (this.hasURL) {
      if (this.element.url.startsWith('https://')) {
        const route = this.element.url;
        window.open(route);
      } else if (this.element.url.startsWith('/')) {
        const route = URL_PATH + this.element.url;
        this.trainingStore.getPdfFromAssets(route).then((data) => {
          let file = new Blob([data], { type: 'application/pdf' });
          FileSaver.saveAs(file, this.element.url.substring(this.element.url.lastIndexOf('/') + 1));
        });
      } else {
        console.error('The path of the current file is not supported.');
      }
    }
  };
}
